import React from 'react'

const Footer = () => {
    return (
        <footer>
        <p>© Copyright Detlef Dumpelmann 2021</p>
      </footer>
    )
}

export default Footer
